export default "__VITE_ASSET__73edec89__"